import React from "react";
import device from "../image/device.png";
import feature1 from "../image/feature1.png";
import feature2 from "../image/feature2.png";
import feature3 from "../image/feature3.png";
import feature4 from "../image/feature4.png";

const Features = () => {
  // Define styles as a string
  const styles = `
/* features.css */

.features-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 50px;
    background-color: #fff;
  }
  
  .features-main {
    display: flex;
  }
  
  .card-section {
    margin-left: 10vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: white;
    border-radius: 20px;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
    padding: 20px;
    max-width: auto;
  }
.card-image{
    max-height:30rem ;
}
  
  .card-header h3 {
    color: #333;
  }
  
  .card-body h2 {
    font-size: 2.5rem;
    color: #5e17eb;
  }
  
  .card-footer {
    margin-top: 20px;
  }
  
  .logos img {
    width: 40px;
    height: 40px;
    margin: 0 5px;
  }
  
  .features-text {
    margin: 30px;
    align-self: center;
    margin-left: 5vw;
  }
  
  .features-text h1 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 30px;
  }
  .spacing {
    display: flex;
    justify-content: flex-start;
  }
  .feature-icons {
    
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
  
  .feature-item {
    text-align: center;
    width:20vw;
  }
  
  .icon-circle {
    width: 6rem;
    height: 6rem;
    border-radius: 50%;
    background: linear-gradient(90deg, #4d88ff, #8a93e7);
    display: flex;
    justify-content: center;
  }
  .icon-image{
    width: 85px;
    height:85px;
  }
  .icon-circle i {
    font-size: 1.5rem;
    color: white;
  }
  
  .feature-item h3 {
    color: #333;
  }
  
  .feature-item p {
    color: #666;
    font-size: 0.9rem;
     text-align: justify;
  }

  @media (max-width: 768px) {
    .features-main {
      flex-direction: column; /* Stack card and features vertically */
      align-items: center; /* Center align items */
    }
  
    .features-text {
      margin-left: 0; /* Remove left margin */
      text-align: center; /* Center text for small screens */
    }
  
    .feature-icons {
      grid-template-columns: 1fr; /* Single column layout */
    }
    .card-section {
        margin-left: -5vw;
      }
    .feature-item{
        width:auto;
    }
     
  }
  
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="features-container" id="feature">
        <div className="features-main">
          <div className="card-section">
            <div>
              <img src={device} alt="Physio-mize" className="card-image" />
            </div>
          </div>

          <div className="features-text">
            <h1>Some of the best features Of Our App!</h1>
            <div className="feature-icons">
              {[
                {
                  icon: feature1,
                  title: "Pain Intensity & Localisation",
                  description:
                    "Track pain points and intensity in real-time using a 3D joint model, enabling better remote treatment adjustments.",
                },
                {
                  icon: feature2,
                  title: "Accurate ROM Measurement",
                  description:
                    "High-precision sensors ensure accurate Range of Motion (ROM) tracking, helping physiotherapists monitor progress in real time.",
                },
                {
                  icon: feature3,
                  title: "Data Visualisation",
                  description:
                    "Intuitive data visualizations make it easy for patients and therapists to track progress and improve treatment adherence.",
                },
                {
                  icon: feature4,
                  title: "Cost Effective",
                  description:
                    "Affordable and accessible, Physio-Mize provides quality physiotherapy solutions to underserved and remote areas.",
                },
              ].map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="spacing">
                    <div className="icon-circle">
                      <img
                        src={feature.icon}
                        alt="Feature Icon"
                        className="icon-image"
                      />
                    </div>
                    <div>
                      <h3>{feature.title}</h3>
                      <p>{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Features;
